import React from 'react';

const Footer = () => {
    return (
        <div className="bg-dark text-light mt-5 d-flex justify-content-between">
           <h6 className="p-3 ml-5 d-flex justify-content-start">Developed with ❤️ By Subha Fairuz</h6>
            <small className="d-flex justify-content-center align-items-center mr-5">Copyright © 2021</small>
        </div>
    );
};

export default Footer;